/**
 * AuthButton Component
 * Microsoft login button with loading states
 */

interface AuthButtonProps {
    onClick: () => void;
    isLoading?: boolean;
    label?: string;
}

export default function AuthButton({
    onClick,
    isLoading = false,
    label = 'Login with Microsoft',
}: AuthButtonProps) {
    return (
        <button
            onClick={onClick}
            disabled={isLoading}
            className="w-full bg-[#2ba6bb] text-white py-3.5 px-6 rounded-lg hover:bg-[#228a9d] transition-all duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-lg hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-[#2ba6bb] focus:ring-opacity-50"
        >
            {isLoading ? (
                <>
                    <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                    Signing in...
                </>
            ) : (
                <>{label}</>
            )}
        </button>
    );
}
